import { createContext, useContext, useState, useEffect } from "react";
import { apiFetchAdmin } from '../../hooks/apiFetch';
import { useNavigate } from 'react-router-dom';
import { useLangUrl } from '../../utilities/useLangUrl';
import Cookies from 'js-cookie';

// import Cookies from 'js-cookie';

const AdminOffersContext = createContext();

export function AdminOffersProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [settingOffers, setSettingOffers] = useState("");
    const langUrl = useLangUrl();

    const navigate = useNavigate();

    useEffect(() => {
        if (!Cookies.get('adminToken')) {
            navigate("/admin/adminLogin")
        }

        async function fetchOffers() {
            setLoading(true);
            try {
                const offersData = await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/offers?page=${currentPage}&limit=8`);
                setSettingOffers(offersData?.data?.data);

            } catch (err) {
                setSettingOffers(null)

            } finally {
                setLoading(false);
            }
        }
        fetchOffers();
    }, [navigate, currentPage, langUrl]);


    return (
        <AdminOffersContext.Provider
            value={{
                loading, setLoading, currentPage, setCurrentPage, settingOffers, setSettingOffers
            }}>
            {children}
        </AdminOffersContext.Provider>
    );
}

export function useAdminOffers() {
    return useContext(AdminOffersContext);
}